export const servicios = [
    {
        "anio": "",
        "descripcion": "Apoyo para el Bienestar y Desarrollo",
        "trimestres": [
            {
                "trimestre": "",
                "urlRuts": "https://ruts.hidalgo.gob.mx/ver/10941",  // URL para RUTS
                "urlCnartys": "" // URL para CNARTyS
            },
        ]
    },
    {
        "anio": "",
        "descripcion": "Bienestar de Madres Trabajadoras",
        "trimestres": [
            {
                "trimestre": "",
                "urlRuts": "https://ruts.hidalgo.gob.mx/ver/11120",  // URL para RUTS
                "urlCnartys": "https://catalogonacional.gob.mx/FichaTramite?traHomoclave=SBIS-2024-11547-002-A" // URL para CNARTyS
            },
        ]
    },
    {
        "anio": "",
        "descripcion": "Programa Xantolo",
        "trimestres": [
            {
                "trimestre": "",
                "urlRuts": "https://ruts.hidalgo.gob.mx/ver/11363",  // URL para RUTS
                "urlCnartys": "https://catalogonacional.gob.mx/FichaTramite?traHomoclave=SBIS-2025-11547-002-A" // URL para CNARTyS
            },
        ]
    },
    {
        "anio": "",
        "descripcion": "Programa de Subsidio al Servicio de Verificación Vehicular",
        "trimestres": [
            {
                "trimestre": "",
                "urlRuts": "https://ruts.hidalgo.gob.mx/ver/11366",  // URL para RUTS
                "urlCnartys": "https://catalogonacional.gob.mx/FichaTramite?traHomoclave=SBIS-2025-11547-005-A" // URL para CNARTyS
            },
        ]
    },
    {
        "anio": "",
        "descripcion": "Formación con Perspectiva de Discapacidad",
        "trimestres": [
            {
                "trimestre": "",
                "urlRuts": "https://ruts.hidalgo.gob.mx/ver/11185",  // URL para RUTS
                "urlCnartys": "https://catalogonacional.gob.mx/FichaTramite?traHomoclave=SBIS-2024-11547-015-A" // URL para CNARTyS
            },
        ]
    },
    {
        "anio": "",
        "descripcion": "Atención Integral a Personas con Discapacidad",
        "trimestres": [
            {
                "trimestre": "",
                "urlRuts": "https://ruts.hidalgo.gob.mx/ver/11186",  // URL para RUTS
                "urlCnartys": "https://catalogonacional.gob.mx/FichaTramite?traHomoclave=SBIS-2024-11547-016-A" // URL para CNARTyS
            },
        ]
    },
    {
        "anio": "",
        "descripcion": "Interpretación de Lengua de Señas Mexicana",
        "trimestres": [
            {
                "trimestre": "",
                "urlRuts": "https://ruts.hidalgo.gob.mx/ver/11217",  // URL para RUTS
                "urlCnartys": "https://catalogonacional.gob.mx/FichaTramite?traHomoclave=SBIS-2024-11547-021-A" // URL para CNARTyS
            },
        ]
    },
    {
        "anio": "",
        "descripcion": "Bienestar de Personas Cuidadoras de Personas con Discapacidad",
        "trimestres": [
            {
                "trimestre": "",
                "urlRuts": "https://ruts.hidalgo.gob.mx/ver/11372",  // URL para RUTS
                "urlCnartys": "https://catalogonacional.gob.mx/FichaTramite?traHomoclave=SBIS-2025-11547-006-A" // URL para CNARTyS
            },
        ]
    },
    {
        "anio": "",
        "descripcion": "Programa de Atención al Pueblo",
        "trimestres": [
            {
                "trimestre": "",
                "urlRuts": "https://ruts.hidalgo.gob.mx/ver/11198",  // URL para RUTS
                "urlCnartys": "https://catalogonacional.gob.mx/FichaTramite?traHomoclave=SBIS-2024-11547-018-A" // URL para CNARTyS
            },
        ]
    },
    {
        "anio": "",
        "descripcion": "Programa de Desarrollo Inclusivo",
        "trimestres": [
            {
                "trimestre": "",
                "urlRuts": "https://ruts.hidalgo.gob.mx/ver/11201",  // URL para RUTS
                "urlCnartys": "https://catalogonacional.gob.mx/FichaTramite?traHomoclave=SBIS-2024-11547-019-A" // URL para CNARTyS
            },
        ]
    },
    {
        "anio": "",
        "descripcion": "Servicios de Información a Actores Sociales, Integrantes de Colectivos Comunitarios",
        "trimestres": [
            {
                "trimestre": "",
                "urlRuts": "https://ruts.hidalgo.gob.mx/ver/1625",  // URL para RUTS
                "urlCnartys": "https://catalogonacional.gob.mx/FichaTramite?traHomoclave=SBIS-2024-11547-003-A" // URL para CNARTyS
            },
        ]
    },
    {
        "anio": "",
        "descripcion": "Registro de Marca",
        "trimestres": [
            {
                "trimestre": "",
                "urlRuts": "https://ruts.hidalgo.gob.mx/ver/1185",  // URL para RUTS
                "urlCnartys": "https://catalogonacional.gob.mx/FichaTramite?traHomoclave=SBIS-2024-11547-004-A" // URL para CNARTyS
            },
        ]
    },
    {
        "anio": "",
        "descripcion": "Asignación de Espacios Eventos y Exposiciones Municipales",
        "trimestres": [
            {
                "trimestre": "",
                "urlRuts": "https://ruts.hidalgo.gob.mx/ver/1186",  // URL para RUTS
                "urlCnartys": "https://catalogonacional.gob.mx/FichaTramite?traHomoclave=SBIS-2024-11547-005-A" // URL para CNARTyS
            },
        ]
    },
    {
        "anio": "",
        "descripcion": "Certificados de Autenticidad de Productos Artesanales",
        "trimestres": [
            {
                "trimestre": "",
                "urlRuts": "https://ruts.hidalgo.gob.mx/ver/1189",  // URL para RUTS
                "urlCnartys": "https://catalogonacional.gob.mx/FichaTramite?traHomoclave=SBIS-2024-11547-006-A" // URL para CNARTyS
            },
        ]
    },
    {
        "anio": "",
        "descripcion": "Asignación de Espacios (Punto de venta HIDARTE) ",
        "trimestres": [
            {
                "trimestre": "",
                "urlRuts": "https://ruts.hidalgo.gob.mx/ver/1188",  // URL para RUTS
                "urlCnartys": "https://catalogonacional.gob.mx/FichaTramite?traHomoclave=SBIS-2024-11547-007-A" // URL para CNARTyS
            },
        ]
    },
    {
        "anio": "",
        "descripcion": "Padrón de las Personas Artesanas Hidalguenses",
        "trimestres": [
            {
                "trimestre": "",
                "urlRuts": "https://ruts.hidalgo.gob.mx/ver/10926",  // URL para RUTS
                "urlCnartys": "https://catalogonacional.gob.mx/FichaTramite?traHomoclave=SBIS-2024-11547-008-A" // URL para CNARTyS
            },
        ]
    },
    
    {
        "anio": "",
        "descripcion": 'Reencuentro Familiar "Raíces Hidalgo"',
        "trimestres": [
            {
                "trimestre": "",
                "urlRuts": "https://ruts.hidalgo.gob.mx/ver/7694",  // URL para RUTS
                "urlCnartys": "https://catalogonacional.gob.mx/FichaTramite?traHomoclave=SBIS-2024-11547-009-A" // URL para CNARTyS
            },
        ]
    },
    {
        "anio": "",
        "descripcion": 'Oficina Itinerante "Primero el Pueblo, Primero los Migrantes"',
        "trimestres": [
            {
                "trimestre": "",
                "urlRuts": "https://ruts.hidalgo.gob.mx/ver/7697",  // URL para RUTS
                "urlCnartys": "https://catalogonacional.gob.mx/FichaTramite?traHomoclave=SBIS-2024-11547-011-A" // URL para CNARTyS
            },
        ]
    },
    {
        "anio": "",
        "descripcion": "Traslado de Restos Mortuorios",
        "trimestres": [
            {
                "trimestre": "",
                "urlRuts": "https://ruts.hidalgo.gob.mx/ver/959",  // URL para RUTS
                "urlCnartys": "https://catalogonacional.gob.mx/FichaTramite?traHomoclave=SBIS-2024-11547-012-A" // URL para CNARTyS
            },
        ]
    },
    {
        "anio": "",
        "descripcion": "Invierte en Ti, Invierte en Hidalgo",
        "trimestres": [
            {
                "trimestre": "",
                "urlRuts": "https://ruts.hidalgo.gob.mx/ver/11187",  // URL para RUTS
                "urlCnartys": "https://catalogonacional.gob.mx/FichaTramite?traHomoclave=SBIS-2024-11547-017-A" // URL para CNARTyS
            },
        ]
    },
    {
        "anio": "",
        "descripcion": 'Doble Nacionalidad “Ya Soy Hidalguense” (Totalmente Gratuito)',
        "trimestres": [
            {
                "trimestre": "",
                "urlRuts": "https://ruts.hidalgo.gob.mx/ver/933",  // URL para RUTS
                "urlCnartys": "https://catalogonacional.gob.mx/FichaTramite?traHomoclave=SBIS-2024-11547-010-A" // URL para CNARTyS
            },
        ]
    },
    {
        "anio": "",
        "descripcion": "Documentos de Viaje Internacional y Asuntos Migratorios (Visas)",
        "trimestres": [
            {
                "trimestre": "",
                "urlRuts": "https://ruts.hidalgo.gob.mx/ver/903",  // URL para RUTS
                "urlCnartys": "https://catalogonacional.gob.mx/FichaTramite?traHomoclave=SBIS-2024-11547-013-A" // URL para CNARTyS
            },
        ]
    },
    {
        "anio": "",
        "descripcion": "Apoyo Económico para Documentos Internacionales",
        "trimestres": [
            {
                "trimestre": "",
                "urlRuts": "https://ruts.hidalgo.gob.mx/ver/11367",  // URL para RUTS
                "urlCnartys": "https://catalogonacional.gob.mx/FichaTramite?traHomoclave=SBIS-2025-11547-007-A" // URL para CNARTyS
            },
        ]
    },
    {
        "anio": "",
        "descripcion": "Apoyo Economico a Personas Migrantes Hidalguenses en Materia de Salud",
        "trimestres": [
            {
                "trimestre": "",
                "urlRuts": "https://ruts.hidalgo.gob.mx/ver/11368",  // URL para RUTS
                "urlCnartys": "https://catalogonacional.gob.mx/FichaTramite?traHomoclave=SBIS-2025-11547-008-A" // URL para CNARTyS
            },
        ]
    },
    {
        "anio": "",
        "descripcion": "Apoyo Económico en el Traslado de Restos",
        "trimestres": [
            {
                "trimestre": "",
                "urlRuts": "https://ruts.hidalgo.gob.mx/ver/11369",  // URL para RUTS
                "urlCnartys": "https://catalogonacional.gob.mx/FichaTramite?traHomoclave=SBIS-2025-11547-009-A" // URL para CNARTyS
            },
        ]
    },
    {
        "anio": "",
        "descripcion": "Apoyo Económico a Migrantes Hidalguenses por Repatriación o Deportación",
        "trimestres": [
            {
                "trimestre": "",
                "urlRuts": "https://ruts.hidalgo.gob.mx/ver/11371",  // URL para RUTS
                "urlCnartys": "https://catalogonacional.gob.mx/FichaTramite?traHomoclave=SBIS-2025-11547-010-A" // URL para CNARTyS
            },
        ]
    },
    {
        "anio": "",
        "descripcion": "Apoyo Económico para Migrantes Hidalguenses por Vulnerabilidad",
        "trimestres": [
            {
                "trimestre": "",
                "urlRuts": "https://ruts.hidalgo.gob.mx/ver/11373",  // URL para RUTS
                "urlCnartys": "https://catalogonacional.gob.mx/FichaTramite?traHomoclave=SBIS-2025-11547-011-A" // URL para CNARTyS
            },
        ]
    },
];
